<template>
  <div class="controls-skeleton">
    <template v-for="i in count" :key="i">
      <a-skeleton-button
        active
        block
        class="controls-skeleton_button"
        :style="getSizeStyle(i)"
      />
    </template>
  </div>
</template>

<script setup>
const props = defineProps({
  count: { type: Number, default: 4 },
  width: { 
    type: [String, Number, Array], 
    default: "220px" 
  },
  height: { type: String, default: "22px" }
})

// Devuelve width dinámico (si mandas array respeta cada ancho)
const getSizeStyle = (index) => {
  if (Array.isArray(props.width)) {
    return {
      width: props.width[index - 1] || props.width.at(-1) || "150px",
      height: props.height,
      display: "flex",
      alignItems: "center",
      borderRadius: "10px"
    }
  }
  return { width: props.width, height: props.height, display: "flex", alignItems: "center", borderRadius: "10px" }
}
</script>

<style lang="sass" scoped>
.controls-skeleton
  display: flex
  gap: 10px
  align-items: center

:deep(.ant-skeleton.ant-skeleton-block .ant-skeleton-button)
  border-radius: 10px !important
  height: 28px !important
</style>